import { HttpMethod } from "../../components/Common/useFetch";
import { RequestOptions } from "../../components/Common/useRequest";
import useKaEmployeeRequest, { KaEmployeeRequestSpec } from "../../components/Common/useKaEmployeeRequest";

export interface UpsertSiteDto {
  customerName: string;
  internalName: string;
  internalSiteId: string;
}

const createSpec = (businessId: string): KaEmployeeRequestSpec => ({
  path: `/employeeApi/businesses/${businessId}/sites`,
  method: HttpMethod.POST,
});

const useCreateSite = (businessId: string, options?: RequestOptions<void>) => {
  return useKaEmployeeRequest<UpsertSiteDto>(createSpec(businessId), options);
}

export default useCreateSite;
